module.exports = __webpack_public_path__ + "img/enerman-etisol_new_light.2d389f16.svg";